import React from 'react';
import MainTemplate from 'pages/templates/MainTemplate';

import Statistics from './Statistics';

const MediaTotalStatus = () => {
  return (
    <MainTemplate className="mb-User">
      <Statistics />
    </MainTemplate>
  );
};

export default MediaTotalStatus;
